import { TopNavBarTabs } from "../types/navigation";

import { zustandStore } from "./zustand.helpers";

export type NavigationState = {
    activeTab: TopNavBarTabs;
    identifier?: string;
};

export interface NavigationActions {
    setActiveTab: (tab: TopNavBarTabs) => void;
    setIdentifier: (identifier?: string) => void;
    resetState: () => void;
}

export const initialState: NavigationState = {
    activeTab: TopNavBarTabs.ALL_INSIGHTS,
    identifier: undefined,
};

export const { store: navigationStore } = zustandStore<
    NavigationState,
    NavigationActions
>("Navigation", initialState, (set: any, get) => ({
    setActiveTab: (tab: TopNavBarTabs) => {
        const state: NavigationState = get();
        set(() => ({
            ...state,
            activeTab: tab,
        }));
    },
    setIdentifier: (identifier?: string) => {
        const state: NavigationState = get();
        set(() => ({
            ...state,
            identifier,
        }));
    },
    resetState: () => set(() => ({ ...initialState })),
}));
